__turbopack_context__.v({
  "confirmation": "Registration-module-scss-module__jQPU0q__confirmation",
  "content": "Registration-module-scss-module__jQPU0q__content",
  "footer": "Registration-module-scss-module__jQPU0q__footer",
  "itsme": "Registration-module-scss-module__jQPU0q__itsme",
  "registration": "Registration-module-scss-module__jQPU0q__registration",
  "wrapper": "Registration-module-scss-module__jQPU0q__wrapper",
});
